import type { UserType } from '@form-factory/schema';
import type { ChatRole } from '@form-factory/schema/enums';
import { v7 as uuid } from 'uuid';

import type { ChatMessageItem } from './types';

/**
 * Helper for creating a message object in chat.
 */
export function createMessage(data: {
  message: string | ChatMessageItem;
  role: ChatRole;
  user?: UserType | null | undefined;
  isInitial?: boolean;
}): ChatMessageItem {
  if (typeof data.message === 'string') {
    return {
      role: data.role,
      content: data.message,
      user: data.user,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      id: uuid(),
      isInitial: data.isInitial ?? false,
    } as ChatMessageItem;
  } else {
    // Extract user from message and ensure it's not overridden
    const { user: messageUser, ...messageRest } = data.message;

    return {
      ...messageRest,
      role: data.message?.role ?? data.role,
      user: messageUser ?? data.user,
      isInitial: data.isInitial ?? false,
    } as ChatMessageItem;
  }
}
